var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMrass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2079,
    height: 2079,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1986,
    y: 886,
    width: 2079,
    height: 2079
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3545,
    y: 1343,
    width: 505,
    height: 623
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3545,
    y: 1343,
    width: 505,
    height: 623
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3447,
    y: 1283,
    width: 727,
    height: 746
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1986 -886)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1986,
    y: 886,
    width: 2079,
    height: 2079,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2395 1925.5C2395 1577.28 2677.28 1295 3025.5 1295 3373.72 1295 3656 1577.28 3656 1925.5 3656 2273.72 3373.72 2556 3025.5 2556 2677.28 2556 2395 2273.72 2395 1925.5Z",
    fill: "#4472C4",
    fillRule: "evenodd",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M551.856 438.362 551.931 438.362 551.931 157.542C568.078 153.404 577.814 136.96 573.676 120.812 569.538 104.665 553.094 94.9291 536.947 99.0671 526.272 101.803 517.937 110.138 515.201 120.812L234.382 120.812 189.018 75.4482C144.343 157.047 139.821 254.694 176.762 340.073 190.003 370.123 208.352 397.65 230.995 421.433L134.218 628.733C130.702 636.308 133.992 645.299 141.567 648.815 143.571 649.745 145.754 650.225 147.963 650.22L335.922 650.22C344.273 650.219 351.043 643.448 351.041 635.097 351.041 632.887 350.556 630.705 349.622 628.702L269.335 456.666C290.325 473.795 313.647 487.847 338.598 498.401 375.284 513.729 414.639 521.644 454.398 521.688 455.706 521.688 457.014 521.688 458.322 521.688 507.408 521.182 555.63 508.712 598.807 485.359ZM398.449 284.955 529.105 154.337C531.51 155.761 534.104 156.84 536.81 157.542L536.81 423.316ZM544.37 113.252C552.722 113.252 559.492 120.022 559.492 128.373 559.492 136.725 552.722 143.495 544.37 143.495 536.019 143.495 529.249 136.725 529.249 128.373 529.249 120.022 536.019 113.252 544.37 113.252ZM515.201 135.934C515.902 138.646 516.984 141.245 518.415 143.653L387.788 274.264 249.503 135.934ZM278.551 512.185 241.942 548.801 205.326 512.185 241.874 433.863C241.893 433.825 241.938 433.81 241.976 433.828 241.991 433.835 242.003 433.848 242.01 433.863ZM198.521 526.762 231.252 559.492 155.645 635.099 148.084 635.099C148.046 635.101 148.014 635.072 148.012 635.035 148.011 635.02 148.015 635.005 148.023 634.993ZM241.942 570.183 306.73 634.97C306.76 635 306.759 635.048 306.729 635.077 306.715 635.091 306.697 635.099 306.677 635.099L177.208 635.099C177.166 635.098 177.133 635.064 177.133 635.022 177.134 635.003 177.141 634.984 177.155 634.97ZM328.24 635.099 252.633 559.492 285.364 526.762 335.869 634.993C335.89 635.024 335.882 635.066 335.85 635.087 335.838 635.096 335.824 635.1 335.809 635.099ZM454.398 506.567C416.623 506.555 379.225 499.043 344.375 484.467 316.357 472.544 290.499 456.077 267.845 435.731L262.787 431.27C231.85 404.586 207.212 371.377 190.643 334.032 158.421 259.478 159.309 174.76 193.085 100.898L573.162 481.065C537.137 497.629 497.995 506.323 458.345 506.567 457.112 506.567 455.91 506.567 454.398 506.567Z",
    stroke: "#000000",
    strokeWidth: 21.0385,
    transform: "matrix(1 0 0 1.0274 3447.38 1283.04)"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrass);
export default __webpack_public_path__ + "static/media/MRASS.ced25e809cc157d77c7e51bcafa46675.svg";
export { ForwardRef as ReactComponent };